"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Recorder = _interopRequireDefault(require("./AudioRecorder/Recorder"));
var _Stopwatch = _interopRequireDefault(require("../common/Stopwatch/Stopwatch"));
var _IconButton = _interopRequireDefault(require("../common/IconButton/IconButton"));
require("./RecordButton.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var RecordButton = function RecordButton(_ref) {
  var onAudioURL = _ref.onAudioURL,
    disabled = _ref.disabled;
  var _useRecorder = (0, _Recorder["default"])(),
    _useRecorder2 = _slicedToArray(_useRecorder, 5),
    audioURL = _useRecorder2[0],
    setAudioURL = _useRecorder2[1],
    isRecording = _useRecorder2[2],
    startRecording = _useRecorder2[3],
    stopRecording = _useRecorder2[4];
  var send = (0, _react.useRef)(false);
  var isHttps = window.location.protocol === 'https:';
  var onAudioSend = function onAudioSend() {
    send.current = true;
    stopRecording();
  };
  (0, _react.useEffect)(function () {
    if (send.current && audioURL) {
      audioURL.data.name = 'audio.ogg';
      audioURL.data.preview = {
        type: 'audio',
        urllocal: audioURL.url
      };
      onAudioURL([audioURL.data]);
      send.current = false;
      setAudioURL(null);
    }
  }, [audioURL]);
  return isRecording ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-time-recording-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-recording-icon',
    onClick: function onClick() {
      return stopRecording();
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon close"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-recording-timer"
  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-recording-timer-icon"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-recording-icon blue',
    onClick: onAudioSend
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon sent"
  }))) : /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    icon: "microphone",
    large: true,
    disabled: disabled || !isHttps,
    onClick: function onClick() {
      return startRecording();
    }
  });
};
var _default = exports["default"] = RecordButton;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/MultimediaMessages/RecordButton.js
// module id = 1421
// module chunks = 0